import React from 'react';

export default function TypeChips({ value = [], options = [], onChange, limit, single }) {
    const toggle = (val) => {
        if (single) {
            if (value.includes(val)) {
                onChange([]);
            } else {
                onChange([val]);
            }
            return;
        }

        const set = new Set(value);
        if (set.has(val)) {
            set.delete(val);
        } else {
            set.add(val);
        }
        onChange(Array.from(set));
    };

    const displayOptions = limit ? options.slice(0, limit) : options;

    return (
        <div className="req-chips">
            {displayOptions.map(opt => (
                <button
                    key={opt.value}
                    type="button"
                    className={`req-chip ${value.includes(opt.value) ? 'active' : ''}`}
                    onClick={() => toggle(opt.value)}
                >
                    {opt.label}
                </button>
            ))}
        </div>
    );
}
